import { getMessages } from '../../../../../../../store/constants';

export const BOARD_BUTTON_ARCHIVE = getMessages().getText('board_details__link_archive');
